document.addEventListener('DOMContentLoaded', () => {
    // Mobile nav drawer
    const burger = document.querySelector('.header__burger');
    const navs = document.querySelector('.header__navs');
    const backdrop = document.querySelector('.header__backdrop');
    const drawerClose = document.querySelector('.header__drawer-close');

    function openDrawer() {
        navs.classList.add('is-open');
        backdrop.classList.add('is-open');
        burger.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
        navs.classList.remove('is-open');
        backdrop.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
    }

    if (burger) {
        burger.addEventListener('click', () => {
            const isOpen = navs.classList.contains('is-open');
            isOpen ? closeDrawer() : openDrawer();
        });
    }

    if (drawerClose) {
        drawerClose.addEventListener('click', closeDrawer);
    }

    if (backdrop) {
        backdrop.addEventListener('click', closeDrawer);
    }

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && navs && navs.classList.contains('is-open')) {
            closeDrawer();
        }
    });

    // Mobile dropdown toggles
    document.querySelectorAll('.header__dropdown-toggle').forEach((toggle) => {
        toggle.addEventListener('click', () => {
            const item = toggle.closest('.header__main-nav-item');
            const isExpanded = item.classList.contains('is-expanded');
            item.classList.toggle('is-expanded', !isExpanded);
            toggle.setAttribute('aria-expanded', String(!isExpanded));
        });
    });
});

import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.rich-text-editor').forEach((element) => {
        ClassicEditor.create(element, {
            toolbar: ['bold', 'italic', 'link'],
        });
    });
});